/**
 * Constants for authentication
 */

// The flow type used for Google OAuth
export const authFlow = 'auth-code';

// The scope for Google OAuth
export const authScope = 'https://www.googleapis.com/auth/chat.memberships.app';
